type InlineLinkProps = {
	children: string;
	to: string;
	newTab?: true;
	tabIndex?: number;
};

export const InlineLink = ({ children, to, newTab }: InlineLinkProps) => (
	<a
		href={to}
		target={newTab ? "_blank" : undefined}
		className="text-brand-accent underline active:text-brand-accent active:underline visited:bg-brand-accent visited:underline"
	>
		{children}
	</a>
);
